import {
  Component,
  ViewEncapsulation,
  input
} from '@angular/core';

export type ActionContentPosition = 'center' | 'end';

@Component({
  selector: 'td-wb-page-action-panel',
  template: '<ng-content />',
  styleUrls: ['page-action-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.td-wb-page-action-panel]': 'true',
    '[class.td-wb-page-action-panel--top]': 'top()',
    '[class.td-wb-page-action-panel--bottom]': 'bottom()',
    '[class.td-wb-page-action-panel--left]': 'left()',
    '[class.td-wb-page-action-panel--right]': 'right()',
    '[class.td-wb-page-action-panel--center]': 'position() === \'center\'',
    '[class.td-wb-page-action-panel--end]': 'position() === \'end\''
  }
})
export class PageActionPanelComponent {

  readonly top = input<boolean>(false);

  readonly bottom = input<boolean>(false);

  readonly left = input<boolean>(true);

  readonly right = input<boolean>(true);

  readonly position = input<ActionContentPosition>(undefined);
}
